import {useCallback, useState} from 'react';
import GoalPlanner from '../cinematic/GoalPlanner';
import {readGuestPlan, saveGuestPlan} from './planDraft';

export default function PublicGoalPlanner({onContinue, ...props}) {
  const [initial] = useState(() => readGuestPlan()?.draft);
  const remember = useCallback(draft => {saveGuestPlan(draft);},[]);
  const continuePlan = draft => {
    saveGuestPlan(draft,true);
    if (onContinue) onContinue();
    else window.location.hash='#login';
  };
  return <GoalPlanner {...props} initialDraft={initial} onDraftChange={remember} onComplete={continuePlan} completeLabel="ذخیره در حساب من"/>;
}
